import { Box, Grid2, Icon, IconButton, Paper, SxProps, Theme, Typography } from "@mui/material";
import { ButtonIconType, ButtonVariant } from "../button/primary.button";
import { IListItemButton } from "../../_common/interface/buttons/iListItemButton.interface";


export function StandardListItem(params: {
    sx?: SxProps<Theme>,
    key: string,
    primary: React.ReactNode,
    primarySubline?: React.ReactNode,
    secondary?: React.ReactNode,
    secondarySubline?: React.ReactNode,
    tertiary?: React.ReactNode,
    buttons?: Array<IListItemButton>

}) {
    return (
        <Grid2 size={{ xs: 12 }} key={params.primary + "_" + params.key}>
            <Paper
                elevation={1}
                sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderRadius: 0,
                    backgroundColor: '#f9f9f9', //Red background for public Actions
                    '&:hover': {
                        backgroundColor: '#f1f1f1', //Red background for public Actions
                    },
                    ...params.sx,
                }}
            >
                {/*<Box display="flex" justifyContent="space-between" alignItems="center" width="100%">*/}
                {/* Left/content */}
                <Box
                    sx={{
                        flex: '1 1 auto',
                        minWidth: 0,              // allows shrinking instead of pushing buttons out
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: 0.25,
                    }}
                >
                    <Typography variant="body1" mr={2}>{params.primary}</Typography>
                    {!!params.primarySubline &&
                        <Typography variant="caption" color="text.secondary" mr={2} display="block">
                            {params.primarySubline}
                        </Typography>
                    }
                </Box>
                {!!params.secondary &&
                    <Box sx={{ flex: '0 0 auto', display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                        <Typography variant="body1" mr={2}>{params.secondary}</Typography>
                        {!!params.secondarySubline &&
                            <Typography variant="caption" color="text.secondary" mr={2} display="block">
                                {params.secondarySubline}
                            </Typography>
                        }
                    </Box>
                }
                {!!params.tertiary &&
                    <Box sx={{ flex: '0 0 auto' }}>
                        <Typography variant="body1" mr={2}> {params.tertiary}</Typography>
                    </Box>
                }
                {/*{(!!params.buttons && !!params.buttons.length) && params.buttons.filter(m => m.display !== false).map((b, index) =>*/}
                {/*    <IconButton disabled={b.disabled} onClick={(e) => { b.onClick(e, index) }} color={b.variant || "primary"}>*/}
                {/*        <Icon>{b.icon}</Icon>*/}
                {/*    </IconButton>*/}
                {/*)}*/}

                {(!!params.buttons && !!params.buttons.length) && (
                    <Box sx={{ flex: '0 0 auto', display: 'flex', gap: 0.5, whiteSpace: 'nowrap' }}>
                        {params.buttons
                            .filter(m => m.display !== false)
                            .map((b, index) => (
                                <IconButton key={index} disabled={b.disabled} onClick={(e) => b.onClick(e, index)} color={b.variant || "primary"} size="small">
                                    <Icon>{b.icon}</Icon>
                                </IconButton>
                            ))}
                    </Box>
                )}
            </Paper>
        </Grid2>
    )
}